import React from 'react';
import { useModalStore } from '@/store';
import ChatInputBanner, { ChatInputBannerAction } from '@/components/ChatInput/ChatInputBanner';
import useTranslation from '@/hooks/useTranslation';

/**
 * Logged-out CTA banner — shown above the composer for anonymous visitors.
 * Replaces the legacy `ChatInputGhostBanner` (which targeted the now-retired
 * ghost-user flow). Tapping the link opens the contextual `AuthCTAModal`.
 */
function ChatInputAuthCTABanner({ level, isCloseable = false, isDetached = false }) {
  const { openModal } = useModalStore(state => state.actions);
  const { t } = useTranslation();

  const handlePress = () => {
    openModal('AuthCTAModal', {
      source: 'composer_banner',
      title: t('chatInput.authCta.modalTitle'),
      subtitle: t('chatInput.authCta.modalSubtitle'),
      icon: 'message-dots',
    });
  };

  return (
    <ChatInputBanner color="tertiary" level={level} isCloseable={isCloseable} isDetached={isDetached}
      actions={<ChatInputBannerAction onPress={handlePress}>{t('chatInput.authCta.bannerLink')}</ChatInputBannerAction>}>
      {t('chatInput.authCta.bannerMessage')}
    </ChatInputBanner>
  );
}

export default React.memo(ChatInputAuthCTABanner);
